import React, { useEffect, useState, useRef } from "react";
import DOMPurify from "dompurify";

const LPPreview = ({ lpUrl }) => {
    const [htmlContent, setHtmlContent] = useState("");
    const iframeRef = useRef(null);

    useEffect(() => {
        if (!lpUrl) return;

        fetch(lpUrl)
            .then(response => response.text())
            .then(html => {
                let sanitizedHtml = DOMPurify.sanitize(html);

                // ✅ CSSのパスを絶対URLに変換
                const absoluteStyleUrl = lpUrl.replace("index.html", "css/style.css");
                const absoluteResetUrl = lpUrl.replace("index.html", "css/reset.css");

                // ✅ HTMLをパース
                const parser = new DOMParser();
                const doc = parser.parseFromString(sanitizedHtml, "text/html");

                // ✅ <head> タグがない場合は追加
                if (!doc.head) {
                    doc.documentElement.insertAdjacentHTML("afterbegin", "<head></head>");
                }

                // ✅ <base> タグを追加
                let baseTag = doc.querySelector("base");
                if (!baseTag) {
                    baseTag = document.createElement("base");
                    baseTag.setAttribute("href", lpUrl.replace("index.html", ""));
                    doc.head.appendChild(baseTag);
                }

                // ✅ <link> タグを追加（動的に適用）
                const linkStyle = document.createElement("link");
                linkStyle.setAttribute("rel", "stylesheet");
                linkStyle.setAttribute("href", absoluteStyleUrl);

                const linkReset = document.createElement("link");
                linkReset.setAttribute("rel", "stylesheet");
                linkReset.setAttribute("href", absoluteResetUrl);

                doc.head.appendChild(linkStyle);
                doc.head.appendChild(linkReset);

                // ✅ 画像のパスを絶対URLに変換
                doc.querySelectorAll("img").forEach(img => {
                    if (img.getAttribute("src")?.startsWith("./")) {
                        img.setAttribute("src", lpUrl.replace("index.html", "") + img.getAttribute("src").substring(2));
                    }
                });

                // ✅ 最終的なHTMLを設定
                setHtmlContent(doc.documentElement.outerHTML);
            })
            .catch(error => {
                console.error("❌ LPの取得に失敗:", error);
                setHtmlContent("<p>LPの読み込みに失敗しました。</p>");
            });
    }, [lpUrl]);

    const adjustIframeHeight = () => {
        const iframe = iframeRef.current;
        if (iframe && iframe.contentWindow && iframe.contentWindow.document) {
            setTimeout(() => {
                const bodyHeight = iframe.contentWindow.document.body.scrollHeight;
                const docHeight = iframe.contentWindow.document.documentElement.scrollHeight;
                const newHeight = Math.max(bodyHeight, docHeight);

                console.log(`📏 設定するiframeの高さ: ${newHeight}px`);
                iframe.style.height = `${newHeight}px`;
            }, 100);
        }
    };

    useEffect(() => {
        if (iframeRef.current) {
            iframeRef.current.onload = adjustIframeHeight;

            // **高さの再調整を5秒ごとに実施（オプション）**
            const interval = setInterval(adjustIframeHeight, 5000);

            return () => clearInterval(interval);
        }
    }, [htmlContent]);

    return (
        <div className="lp-container">
            {htmlContent ? (
                <iframe
                    ref={iframeRef}
                    srcDoc={htmlContent}
                    className="lp-preview"
                    title="LP Preview"
                    style={{
                        width: "100%",
                        border: "none",
                        minHeight: "120vh", // ✅ ビューポートの1.2倍の高さを最低限確保
                        overflow: "hidden"
                    }}
                />
            ) : (
                <p>🔄 LPを読み込み中...</p>
            )}
        </div>
    );
};

export default LPPreview;
